import { BasedOnCalculation, LocationRoleType } from './selectors';
export function createEmptyRole() {
    return {
        id: null,
        roleType: '',
        customRoleName: '',
        roleAppliesTo: '',
        basedOnCalculation: BasedOnCalculation.Fte,
        ratio: null,
        isNew: true,
        isDirty: true,
        isDeleted: false,
    };
}
export function createDefaultFormState() {
    return {
        roles: [createEmptyRole()],
        isDirty: false,
    };
}
export function getRoleName(role) {
    if (role.roleType === LocationRoleType.Custom)
        return role.customRoleName;
    return role.roleType;
}
